<div data-cy="insurance-company-manager-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="insurance-company-manager-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="insurance-company-manager-header">
      <div class="section-header-title" data-cy="insurance-company-manager-title">
        Manage Insurance Companies
      </div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column;" data-cy="insurance-company-manager-content">

      <app-organization-configuration [showOnlyInsurance]="true" data-cy="insurance-company-manager-org-config"></app-organization-configuration>

    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="insurance-company-manager-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="close(false)" class="tdo-button tdo-close" style="margin-right: 10px;" data-cy="insurance-company-manager-close-button">Close</button>
    </div>

  </div>
</div>
